module.exports = __webpack_public_path__ + "img/stapel-01.9903ca05.svg";